




export default {
    name: 'Button',
    props: {
        type: {
            type: String,
            required: true,
        },
        text: {
            type: String,
            required: false
        },
        loading: {
            type: Boolean,
            required: false
        },
    },
}
